import { render } from "./WhySection.vue?vue&type=template&id=9d571064&scoped=true"
import script from "./WhySection.vue?vue&type=script&lang=js"
export * from "./WhySection.vue?vue&type=script&lang=js"

import "./WhySection.vue?vue&type=style&index=0&id=9d571064&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d571064"]])

export default __exports__